export const REVIEW_SESSION_KEY = "CP_REVIEW_SESSION";

export function getReviewSession() {
  try {
    return JSON.parse(localStorage.getItem(REVIEW_SESSION_KEY));
  } catch {
    return null;
  }
}

export function saveReviewSession(reviewSession) {
  localStorage.setItem(REVIEW_SESSION_KEY, JSON.stringify(reviewSession));
}

export function clearReviewSession() {
  localStorage.removeItem(REVIEW_SESSION_KEY);
}
